import { PlatinumSingle } from './PlatinumSingle';
import { PlatinumMulti } from './PlatinumMulti';

export default {
    multi: PlatinumMulti,
    single: PlatinumSingle,
};
